export default __webpack_public_path__ + "static/media/cs_icon_04_on.d6a58c49.png";